/* eslint-disable prefer-template */
/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CButton,
  CFormGroup,
  CLabel,
  CBadge
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";

class OccurenceDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      referral: "",
      description: "",
      selectedType: [],
      usersEdit: null,
      detail: false,
      created_at: "",
      loading: true,
      ciente: null,
      file: null,
      name: null,
      created_by: ""
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}communication/occurrence/singleView/${id}`, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`
        }
      })
      .then(
        resp => {
          const InicioString = URL.public + "uploads/activity/";

          let EstouCiente = false;

          resp.data.data.aware.map(ciente => {
            if (ciente.user_id === this.props.user.user.id) EstouCiente = true;
          });
          const currentDate = new Date(resp.data.data.created_at);
          const date = currentDate.getDate();
          const month = currentDate.getMonth();
          const year = currentDate.getFullYear();
          const hour = currentDate.getHours();
          const minutes = currentDate.getMinutes();

          const dateString = `${date}/${
            month + 1
          }/${year} - ${hour}:${minutes}`;
          this.setState(
            {
              referral: resp.data.data.referral,
              description: resp.data.data.description,
              selectedType: [
                {
                  type_id: resp.data.data.type_id
                }
              ],
              usersEdit: resp.data.data.users,
              created_at: dateString,
              ciente: EstouCiente,
              file: resp.data.data?.uploads[0]?.file || null,
              name:
                resp.data.data.uploads[0]?.file.replace(InicioString, "") ||
                null,
              created_by: resp.data.data.user.name
            },
            () => {
              this.setState({
                edit: true,
                loading: false
              });
            }
          );
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    // Usuário visualizou a ocorrência
    const objView = {
      occurrence_id: id,
      user_id: this.props.user.id,
      viewed: true
    };

    axios.post(`${URL.api}communication/occurrence/view`, objView, {
      headers: { Authorization: `Bearer ${this.props.user.token}` }
    });
  }

  EstouCiente() {
    const { id } = this.props.match.params;

    const obj = {
      occurrence_id: id,
      user_id: this.props.user.id,
      aware: true
    };
    axios
      .post(`${URL.api}communication/occurrence/aware`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.componentDidMount();
      });
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/notice/me", to: "/notice/me" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardBody>
              <CFormGroup>
                <CLabel className="titulo d-block">Descrição</CLabel>
                <CLabel>{this.state.description}</CLabel>
              </CFormGroup>
              <CFormGroup>
                <CLabel className="titulo d-block">Encaminhamento</CLabel>
                <CLabel>{this.state.referral}</CLabel>
              </CFormGroup>
              <CFormGroup>
                <CLabel className="titulo d-block">Data e Hora</CLabel>
                <CLabel>{this.state.created_at}</CLabel>
              </CFormGroup>
              <CFormGroup>
                <CLabel className="titulo d-block">Criado por</CLabel>
                <CLabel>{this.state.created_by}</CLabel>
              </CFormGroup>
              <CFormGroup>
                {this.state.file && (
                  <>
                    <CLabel className="titulo d-block">Anexo</CLabel>{" "}
                    {isImage(this.state.file) ? (
                      <img
                        src={this.state.file}
                        alt="Anexo"
                        className="rounded-lg cursor"
                        onClick={() => window.open(this.state.file, "_blank")}
                        style={{ height: "100px" }}
                      />
                    ) : (
                      <CBadge
                        color="light"
                        className="mfe-2 p-2 cursor btn-light"
                        onClick={() => window.open(this.state.file, "_blank")}
                      >
                        <i className="fa fa-file mr-2"></i>
                        {this.state.name}
                      </CBadge>
                    )}
                  </>
                )}
              </CFormGroup>{" "}
              <div className="x">
                {this.state.ciente && (
                  <CButton color="dark" className="ciente" disabled="true">
                    Estou Ciente <i className="fa fa-thumbs-o-up"></i>
                  </CButton>
                )}
                {!this.state.ciente && (
                  <CButton
                    color="success"
                    className="ciente"
                    onClick={() => this.EstouCiente()}
                  >
                    Estou Ciente
                  </CButton>
                )}
              </div>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}
const isImage = file => {
  const lower = file.toLowerCase();
  return (
    file &&
    (lower.endsWith("jpg") ||
      lower.endsWith("png") ||
      lower.endsWith("jpeg") ||
      lower.endsWith("gif") ||
      lower.endsWith("bmp") ||
      lower.endsWith("svg") ||
      lower.endsWith("tiff") ||
      lower.endsWith("webp"))
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(OccurenceDetail);
